__turbopack_context__.v({
  "icon": "ViewMore-module__01UmTa__icon",
  "main": "ViewMore-module__01UmTa__main",
  "wrapper": "ViewMore-module__01UmTa__wrapper",
});
